// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './constants/locales/en-US.json';
import sc from './constants/locales/sc-HK.json';
import tc from './constants/locales/tc-HK.json';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: en,
  },
  sc: {
    translation: sc,
  },
  tc: {
    translation: tc,
  },
  // 'zh-HK': {
  //   translation: hk,
  // },
};

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources,
  lng: 'en',
  // lng: 'zh-HK',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});


export default i18n;


// WEBPACK FOOTER //
// src/i18n.js